import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Offers from "../pages/offers/page";
import Realisations from "../pages/realisations/page";
import Formation from "../pages/formation/page";
import Actualites from "../pages/actualites/page";
import Contact from "../pages/contact/page";
import Identite from "../pages/identite/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/a-propos",
    element: <About />,
  },
  {
    path: "/offres",
    element: <Offers />,
  },
  {
    path: "/realisations",
    element: <Realisations />,
  },
  {
    path: "/formation",
    element: <Formation />,
  },
  {
    path: "/actualites",
    element: <Actualites />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/identite",
    element: <Identite />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;